import { createFileRoute } from "@tanstack/react-router";

import QuestsOverview from "@/components/Loyalty/QuestsOverview";

const Component = () => {
  const search = Route.useSearch();
  return <QuestsOverview showAllEnded={search.status === "ended"} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/")({
  component: Component,
  validateSearch: (search: Record<string, unknown>): { status?: "ended" } =>
    search.status === "ended" ? { status: "ended" } : {},
});
